import { render, staticRenderFns } from "./73.vue?vue&type=template&id=80f9138c&"
import script from "./73.vue?vue&type=script&lang=js&"
export * from "./73.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports